<template>
  <div class="grid">
    <div class="border pa-5 d-flex flex-wrap">
      <BaseInput
        type="autocomplete"
        v-model="filter.checked.projects"
        :items="Object.values(filter.projects)"
        item-text="text"
        item-value="id"
        :label="localStorage.translations.pages['planning_orders'].table['proekt']"
        placeholder="—"
        multiple
        minimize
        small-chips
        max-width="500px"
      />
      <BaseInput
        type="autocomplete"
        v-model="filter.checked.employees"
        :items="Object.values(filter.employees)"
        item-text="text"
        item-value="id"
        :label="localStorage.translations.pages.finance['period-table'].employee"
        placeholder="—"
        multiple
        minimize
        small-chips
        max-width="500px"
      />
      <div class="ml-auto mt-5">
        <BaseButton
          :text="localStorage.translations.pages.common.buttons['clear']"
          @click="clearFilter"
          reverse
          height="30"
          :disabled="!filter.compare.projects.length && !filter.compare.employees.length"
        />
        <BaseButton
          :text="localStorage.translations.pages.common.buttons['primenit']"
          @click="updatePeriod"
          height="30"
          class="ml-4"
          :disabled="!changed"
        />
      </div>
    </div>
    <template v-if="Object.keys(projects).length">
      <template v-if="!ganttPage">
        <FinanceSalarySliceShowTable :key="key" class="horizontalScroll">
          <FinanceSalarySliceShowTableHeader :responsible-total-show="false"/>
          <FinanceSalarySliceShowTableTotal
            v-for="(project, p) in projects"
            :key="'total_project_' + p"
            :works="Object.values(project.work_types)"
            :extras="Object.values(project.extras)"
            :project-name="project.name"
            :position-plus="project.positionPlus"
            :responsible-total-show="false"
          />
        </FinanceSalarySliceShowTable>
      </template>
      <template v-if="filteredReports">
        <div>
          <div
            v-for="(employee, e) in filteredReports.all.employees"
            :key="'employee' + e"
            class="horizontalScroll"
          >
            <FinanceSalarySliceShowEmployee
              :data="employee"
              :id="e"
              :period="period"
              :check-edit-access="checkEditAccess"
              :on-update="onUpdate"
              :ref="'employee' + e"
              :collection="filteredReports"
              :responsible-show="responsibleShow"
              :foreman-visible="showForemanColumn"
              @toggle-foreman="toggleForemanColumn"
            />
          </div>
          <FinanceSalarySliceShowTable v-if="responsibleShow" total-responsible class="horizontalScroll">
            <div slot="title" class="pb-5 subtitle">
              {{ localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main }}
            </div>
            <FinanceSalarySliceShowTableHeader total-responsible />
            <FinanceSalarySliceShowTableTotal total-responsible
              v-for="(resp, r) in projects"
              :key="r + '_responsible'"
              :responsible="resp"
            />
          </FinanceSalarySliceShowTable>
        </div>
        <div class="fixedBtn">
          <FinanceSalarySliceShowPdf
            :key="key"
            :projects="projects"
            :period="period"
            :employees="employees"
            :disabled="changedData"
            :responsible="projects"
            :responsible-show-total="responsibleShow"
            :foreman-visible="showForemanColumn"
          />
        </div>
      </template>
    </template>
    <template v-else>
      <Plug class="mt-10" />
    </template>

  </div>
</template>

<script>
import axios from 'axios'
import {mapActions, mapGetters} from 'vuex'
import FinanceSalarySliceShowTable from 'components/finance/salary/show/FinanceSalarySliceShowTable'
import FinanceSalarySliceShowTableHeader from 'components/finance/salary/show/FinanceSalarySliceShowTableHeader'
import FinanceSalarySliceShowTableTotal from 'components/finance/salary/show/FinanceSalarySliceShowTableTotal'
import FinanceSalarySliceShowTableByDays from 'components/finance/salary/show/FinanceSalarySliceShowTableByDays'
import FinanceSalarySliceShowPdf from "components/finance/salary/show/FinanceSalarySliceShowPdf";
import FinanceSalarySliceShowEmployee from "components/finance/salary/FinanceSalarySliceShowEmployee";
import BaseButton from "components/base/BaseButton";
import Plug from "components/Plug";

export default {
  name: 'salarySliceShow',
  components: {
    Plug,
    BaseButton,
    FinanceSalarySliceShowEmployee,
    FinanceSalarySliceShowPdf,
    //FinanceSalarySliceShowTableByDays,
    FinanceSalarySliceShowTableTotal,
    FinanceSalarySliceShowTableHeader,
    FinanceSalarySliceShowTable,
  },
  data: () => ({
    minWidth: 1500,
    maxWidth: 2400,
    key: 0,
    loading: false,
    showForemanColumn: true,
    salaryPeriodRoles: null,
    loadingSalaryPeriodRoles: false,
    filter: {
      employees: {},
      projects: {},
      checked: {
        employees: [],
        projects: [],
      },
      compare: {
        employees: [],
        projects: [],
      }
    },
  }),
  computed: {
    ...mapGetters('employeeSalaryPeriod', ['employeeSalaryPeriod']),
    ...mapGetters(['apiDomain']),
    salaryPeriodType() {
      return this.employeeSalaryPeriod?.period?.type || null
    },
    allowedRoleIds() {
      if (!this.salaryPeriodType) return null
      if (!this.salaryPeriodRoles) return null
      const roles = this.salaryPeriodRoles?.[this.salaryPeriodType] || []
      if (!Array.isArray(roles)) return []
      return roles.map((roleId) => Number(roleId)).filter((roleId) => Number.isFinite(roleId))
    },
    filteredReports() {
      const reports = this.employeeSalaryPeriod?.reports
      if (!reports) return null
      if (this.allowedRoleIds === null) return reports
      return {
        ...reports,
        all: this.filterReportsGroup(reports.all),
        current: this.filterReportsGroup(reports.current),
        previous: this.filterReportsGroup(reports.previous),
      }
    },
    routes() {
      return []
    },
    projects() {
      const reports = this.filteredReports
      let result =
        reports && reports.all
          ? reports.all.projects || {}
          : {}
      let positionPlus = 0
      for (let i in result) {
        result[i].id = i
        result[i].positionPlus = positionPlus
        result[i].responsible = result[i]?.responsible ? Object.values(result[i].responsible) : []
        result[i].responsibleShow = result[i]?.responsible ? Object.keys(result[i].responsible).length > 0 : false
        positionPlus += Object.keys(result[i]['work_types']).length +
          (Object.keys(result[i]['extras']).length ? 1 : 0)
      }
      return result
    },
    responsibleShow() {
      let result = false
      for (let pr in this.projects) {
        if (this.projects[pr].responsibleShow)
          result = true
      }
      return result
    },
    period() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.key++
      let temp =
        this.employeeSalaryPeriod && this.employeeSalaryPeriod.period
          ? Object.values(this.employeeSalaryPeriod.period)
          : []
      if (!temp.length) return {}
      let s = temp[1].split('/')
      let e = temp[2].split('/')
      return {
        term: temp[1].split('/').join('.') + ' - ' + temp[2].split('/').join('.') + ' ',
        weeks: temp[3],
        start: s[2] + '-' + s[1] + '-' + s[0],
        end: e[2] + '-' + e[1] + '-' + e[0],
      }
    },
    employees() {
      let result = []
      if (this.filteredReports) {
        for (let i in this.filteredReports.all.employees) {
          if (this.$refs['employee' + i] && this.$refs['employee' + i][0]) {
            result.push(this.$refs['employee' + i][0].employee)
          }
        }
      }
      return result
    },
    ganttPage() {
      return this.$route.name.includes('Gantt')
    },
    pageName() {
      return this.$route.name.includes('Gantt')
        ? this.$route.name.replace('Gantt', '')
        : this.$route.name
    },
    checkEditAccess() {
      return this.$userCheckAccess({
        abilities: 'edit_salary',
      })
    },
    changedData() {
      let result = [false]
      if (this.filteredReports && this.filteredReports.all.employees)
        for (let e in this.filteredReports.all.employees)
          if (this.$refs['employee' + e] && this.$refs['employee' + e][0]) {
            let temp = this.$refs['employee' + e][0].changedData
            result = result.concat(Object.values(temp).map(d => d.changedData))
          }
      return !result.every(e => { return !e })
    },
    changed() {
      if (this.filter.compare.employees.length !== this.filter.checked.employees.length)
        return true
      if (this.filter.compare.projects.length !== this.filter.checked.projects.length)
        return true
      for (let i in this.filter.compare.employees)
        if (!this.filter.compare.employees.includes(this.filter.checked.employees[i]))
          return true
      for (let i in this.filter.compare.projects)
        if (!this.filter.compare.projects.includes(this.filter.checked.projects[i]))
          return true
      return false
    },
  },
  created() {
    this.fetchSalaryPeriodRoles()
    this.updatePeriod()
  },
  methods: {
    ...mapActions('employeeSalaryPeriod', ['onEmployeeSalaryPeriod']),
    ...mapActions('workClientProjectsPeriodReportUpdate', [
      'onWorkClientProjectsPeriodReportUpdate',
    ]),
    toggleForemanColumn() {
      this.showForemanColumn = !this.showForemanColumn
      this.key++
    },

    async updatePeriod() {
      await this.onEmployeeSalaryPeriod({
        id: this.$route.params.period_id,
        user: this.filter.checked.employees,
        project: this.filter.checked.projects,
      }).then(() => {
        if (this.filteredReports) {
          this.applyFilterOptions(this.filteredReports)
          this.syncFilterCompare()
        }
        this.key++
      })
    },

    clearFilter() {
      this.filter.checked.projects = []
      this.filter.checked.employees = []
      this.updatePeriod()
    },

    async onUpdate(data, switchValue, extra, responsible) {
      if (data && data.length > 0) {
        this.loadingAnimationFullPage = true
        await this.onWorkClientProjectsPeriodReportUpdate({
          id: this.$route.params.report_id,
          data: responsible ? data.map(i => i.id) : data,
          paid: true,
          responsible: responsible,
          extra: extra,
        }).then(() => {
          this.updatePeriod()
        })
      }
    },
    async fetchSalaryPeriodRoles() {
      this.loadingSalaryPeriodRoles = true
      try {
        const response = await axios.get(
          this.apiDomain + '/api/admin/common/company/salary-period-roles',
        )
        this.salaryPeriodRoles =
          response?.data?.salary_period_roles ??
          response?.data?.data?.salary_period_roles ??
          null
        if (this.filteredReports) {
          this.applyFilterOptions(this.filteredReports)
          this.syncFilterCompare()
          this.key++
        }
      } catch (error) {
        this.salaryPeriodRoles = null
      } finally {
        this.loadingSalaryPeriodRoles = false
      }
    },
    applyFilterOptions(reports) {
      if (!reports || !reports.all) return
      const employees = reports.all.employees || {}
      const projects = reports.all.projects || {}
      const employeeIds = new Set(Object.keys(employees).map(String))
      const projectIds = new Set(Object.keys(projects).map(String))
      this.filter.checked.employees = this.filter.checked.employees.filter((id) =>
        employeeIds.has(String(id)),
      )
      this.filter.checked.projects = this.filter.checked.projects.filter((id) =>
        projectIds.has(String(id)),
      )
      this.filter.employees = {}
      this.filter.projects = {}
      for (let i in employees) {
        this.filter.employees[i] = {
          id: i,
          text: employees[i]['first_name'] + ' ' + employees[i]['last_name'],
        }
      }
      for (let i in projects) {
        this.filter.projects[i] = {
          id: i,
          text: projects[i].name,
        }
      }
    },
    syncFilterCompare() {
      this.filter.compare.employees = Object.assign([], this.filter.checked.employees)
      this.filter.compare.projects = Object.assign([], this.filter.checked.projects)
    },
    filterReportsGroup(group) {
      if (!group) {
        return { employees: {}, projects: {}, start_day: null, end_day: null }
      }
      const allowed = new Set(this.allowedRoleIds || [])
      const employees = {}
      if (group.employees) {
        for (let id in group.employees) {
          const employee = group.employees[id]
          const roleId = Number(employee.role_id)
          if (allowed.has(roleId)) {
            employees[id] = employee
          }
        }
      }
      const projects = this.aggregateProjectsFromEmployees(
        employees,
        group.projects || {},
      )
      return {
        ...group,
        employees,
        projects,
      }
    },
    aggregateProjectsFromEmployees(employees, sourceProjects) {
      const projects = {}
      const projectEntries = sourceProjects || {}
      for (let employeeId in employees) {
        const employee = employees[employeeId]
        if (!employee.projects) continue
        for (let projectId in employee.projects) {
          const employeeProject = employee.projects[projectId]
          if (!projects[projectId]) {
            const sourceProject = projectEntries[projectId] || {}
            projects[projectId] = {
              internal_project_id:
                sourceProject.internal_project_id ?? employeeProject.internal_project_id ?? null,
              name: sourceProject.name ?? employeeProject.name ?? '',
              work_types: {},
              extras: {},
              responsible: sourceProject.responsible || {},
            }
          }
          this.aggregateWorkItems(
            projects[projectId].work_types,
            employeeProject.work_types,
          )
          this.aggregateWorkItems(projects[projectId].extras, employeeProject.extras)
        }
      }
      return projects
    },
    aggregateWorkItems(target, items) {
      if (!items) return
      for (let itemId in items) {
        const item = items[itemId]
        if (!target[itemId]) {
          target[itemId] = {
            name: item.name,
            is_hourly: item.is_hourly,
            measure: item.measure,
            salary: item.salary,
            employee_report: 0,
            approved_report: 0,
            paid_report: 0,
            salary_sum: 0,
          }
        }
        target[itemId].employee_report += Number(item.employee_report || 0)
        target[itemId].approved_report += Number(item.approved_report || 0)
        target[itemId].paid_report += Number(item.paid_report || 0)
        target[itemId].salary_sum += Number(item.salary_sum || 0)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.flex-wrap {
  column-gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    column-gap: 12px;
  }
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-row-gap: 30px;
}

.horizontalScroll {
  @media #{map-get($display-breakpoints, 'lg-and-down')} {
    overflow-x: scroll;
    max-width: 93vw;
  }
}

:deep() .subtitle {
  color: #277faf;
  font-weight: bolder;
}

.border {
  border: 1px solid #bdbdbd;
  border-radius: 10px;
}
</style>
